/**
 * Subdominio (slug) del portal de cada organismo (jul-2026, doc 06 §1.4):
 * `<subdominio>.instructor.intikipu.cl`. NO implica infraestructura por
 * cliente — todos los subdominios resuelven por un CNAME wildcard al MISMO
 * CloudFront pool; el slug es solo un dato del registro `Organismo` que
 * define la URL de entrada de esa institución. El aislamiento real sigue
 * siendo el claim `custom:org_id` del JWT (doc 01 §5.3), nunca el hostname.
 */
/** Minúsculas/dígitos/guiones, 3–40 chars, sin guion inicial/final. */
const PATRON_SUBDOMINIO = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/;
/**
 * Slugs que nunca puede tomar una institución: o ya tienen dueño (operador,
 * la landing vive en el apex) o son genéricos que confundirían/permitirían
 * suplantación (www, api, admin...).
 */
export const SUBDOMINIOS_RESERVADOS = [
    'www',
    'operador',
    'admin',
    'api',
    'app',
    'portal',
    'panel',
    'instructor',
    'intikipu',
    'mail',
    'login',
    'auth',
    'demo',
    'test',
];
/** Devuelve el motivo de rechazo, o null si el subdominio es válido. */
export function motivoSubdominioInvalido(subdominio) {
    if (!PATRON_SUBDOMINIO.test(subdominio)) {
        return (`Subdominio inválido: "${subdominio}". Use 3–40 caracteres, solo minúsculas, ` +
            'dígitos y guiones (sin guion al inicio/final). Ej: "cobquecura", "hospital-linares".');
    }
    if (SUBDOMINIOS_RESERVADOS.includes(subdominio)) {
        return `El subdominio "${subdominio}" está reservado por la plataforma.`;
    }
    return null;
}
/**
 * Sugerencia de slug a partir del nombre de la institución (para pre-llenar
 * el formulario del panel; el operador siempre puede corregirla).
 */
export function sugerirSubdominio(nombre) {
    return nombre
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // sin tildes/diacríticos (ñ→n)
        .replace(/\b(ilustre|municipalidad|hospital|servicio|de|del|la|el|los|las)\b/g, '')
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40);
}
/**
 * URL del portal de una institución. `template` viene de la config del
 * ambiente: en prod con dominio wildcard es "https://{slug}.instructor.intikipu.cl";
 * en dev (sin dominio propio) es la URL plana de CloudFront — ahí todos los
 * organismos comparten la misma URL y el slug no aparece.
 */
export function urlPortal(template, subdominio) {
    if (template.includes('{slug}')) {
        return subdominio ? template.replace('{slug}', subdominio) : '';
    }
    return template;
}
//# sourceMappingURL=subdominio.js.map